/*
  Scripts

  1. Libraries
  2. EventHandlers
  3. Integrations
  4. Page Specific JS
  5. Utilities

*/

// 1. Libraries
// 2. EventHandlers

var ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
}

  // 2.1 Mobile Slider - Arrow Functionality
  ready(() => {

    let mobileSliderCount = document.querySelectorAll(".mobile-slider").length;
 if (mobileSliderCount >= 1){


    let mobileSliderArray = document.querySelectorAll(".mobile-slider__arrow");
    mobileSliderArray.forEach(function(elem) {
      elem.addEventListener("click", function(e){
        if (this.classList.contains("mobile-slider__arrow--right")){
          mobileSlider = this.parentElement.parentElement.querySelector(".mobile-slider__slides");
          scrollWidth = mobileSlider.clientWidth;
          mobileSlider.scrollLeft += scrollWidth;
        }
        else if (this.classList.contains("mobile-slider__arrow--left")){
          mobileSlider = this.parentElement.parentElement.querySelector(".mobile-slider__slides");
          scrollWidth = mobileSlider.clientWidth;
          mobileSlider.scrollLeft -= scrollWidth;
        }
      });
    });

  }

});
// 3. Integrations
// 4. Page Specific JS

  // Responsive Table on article and page templates - add heading as data attribute
  function hasClass(ele,cls) {
       return ele.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)'));
  }

  const pageType = document.querySelector("body");
  ready(() => {
    if(hasClass(pageType, "page" ) || hasClass(pageType, "article") ){
          document.querySelectorAll("table").forEach(table => {

            let allThs = table.querySelectorAll('th');
            let allThsArr = Array.from(allThs);
            let allTds = table.querySelectorAll('td');
            let allTdsArr = Array.from(allTds);

            for(const [index,value] of allThsArr.entries()){
                table.querySelectorAll(`td:nth-child(${index + 1})`).forEach(td => {
                  td.dataset.index = allThsArr[index].innerHTML + ": ";
                })
            }


           })

        }

  })



$(document).ready(function() {
  $("#cart_form .cart__remove-btn").on("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    $.post('/cart/change.js', {
      line: e.target.getAttribute("data-line-id"),
      properties: {},
      quantity: 0,
    }).always(() => window.location.reload());
  });
});

// 5. Utilities
